import React, { Suspense } from 'react';
import './styles/mobile-menu-fix.css';
import CssBaseline from '@mui/material/CssBaseline';
import { trTR } from '@mui/material/locale';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// App.tsx dosyasında QueryClientProvider'a gerek yok, index.tsx'te zaten tanımlanmış
// Remove DateAdapter imports for now
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import * as trLocale from 'date-fns/locale/tr';

// Layout components

// Authentication

// Session Management - Oturum süresi uyarıları kaldırıldı

// Dashboard

// Customer pages
import CustomerView from './pages/Customers/CustomerView';
import CustomerDetail from './pages/Customers/CustomerDetail';
import CustomerRegistration from './pages/Customers/CustomerRegistration';
import CustomerRegister from './pages/CustomerRegister';

// Vendor pages
import VendorList from './pages/Vendors/VendorList';
import VendorCreate from './pages/Vendors/VendorCreate';
import VendorDetail from './pages/Vendors/VendorDetail';
import VendorEdit from './pages/Vendors/VendorEdit';

// Invoice pages
import InvoiceList from './pages/Invoices/InvoiceList';
import InvoiceForm from './pages/Invoices/InvoiceForm';
import InvoiceDetail from './pages/Invoices/InvoiceDetail';
import PurchaseInvoices from './pages/Invoices/PurchaseInvoices';
import SalesInvoices from './pages/Invoices/SalesInvoices';
import WholesaleInvoices from './pages/Invoices/WholesaleInvoices';
import WholesalePurchaseInvoices from './pages/Invoices/WholesalePurchaseInvoices';

// New Invoice pages
import InvoiceListPage from './pages/invoice/InvoiceListPage';
import InvoiceDetailPage from './pages/invoice/InvoiceDetailPage';
import InvoiceCreatePage from './pages/invoice/InvoiceCreatePage';

// Order pages
import OrderListPage from './pages/orders/OrderListPage';
import OrderDetailPage from './pages/orders/OrderDetailPage';
import OrderFormPage from './pages/orders/OrderFormPage';
import CreateWholesaleOrder from './pages/orders/CreateWholesaleOrder';

// Mobile Menu
// Mobile Sales Landing
import SalesMenu from './pages/SalesMenu';
import CustomerQR from './pages/CustomerQR';

// Profile
import Profile from './pages/Profile';
import ProfilePage from './pages/Profile/ProfilePage';

// User Management
import Users from './pages/Users';
import Roles from './pages/settings/Roles';
import UserGroups from './pages/settings/UserGroups';
import ModulePermissions from './pages/settings/ModulePermissions';
import SettingsPage from './pages/settings/SettingsPage';

// Product pages
import ProductList from './pages/Products/ProductList';
import ProductDetail from './pages/Products/ProductDetail';
import ProductForm from './pages/Products/ProductForm';
import ProductPriceList from './pages/Products/ProductPriceList';

// Database Management pages
import DatabaseList from './pages/settings/DatabaseList';
import UserDatabaseList from './pages/settings/UserDatabaseList';
import AuditLogViewer from './components/admin/AuditLogViewer';
import AuthGuard from './components/Auth/AuthGuard';
import BarcodeSettingsForm from './components/common/BarcodeSettingsForm';
import MainLayout from './components/Layout/Layout';
import { AuthProvider, useAuth } from './contexts/Auth';
import { BarcodeSettingsProvider } from './contexts/BarcodeSettingsContext';

// Material pages

 
// Inventory pages
import WarehouseTransferDetailPage from './pages/inventory/WarehouseTransferDetailPage';
import WarehouseTransferFormPage from './pages/inventory/WarehouseTransferFormPage';
import ProductionOrderListPage from './pages/inventory/ProductionOrderListPage';
import ProductionOrderDetailPage from './pages/inventory/ProductionOrderDetailPage';
import ProductionOrderFormPage from './pages/inventory/ProductionOrderFormPage';
import ConsumptionOrderListPage from './pages/inventory/ConsumptionOrderListPage';
import ConsumptionOrderDetailPage from './pages/inventory/ConsumptionOrderDetailPage';
import ConsumptionOrderFormPage from './pages/inventory/ConsumptionOrderFormPage';

// Exchange Rate pages
import ExchangeRatesPage from './pages/finance/ExchangeRatesPage';
import CrossRatesPage from './pages/finance/CrossRatesPage';
import HistoricalRatesPage from './pages/finance/HistoricalRatesPage';
import ExchangeRateManagementPage from './pages/admin/ExchangeRateManagementPage';

// Cash Management Pages
import CashReceiptPage from './pages/cash/CashReceiptPage';
import CashPaymentPage from './pages/cash/CashPaymentPage';
import CashTransferPage from './pages/cash/CashTransferPage';
import CashReceiptListPage from './pages/cash/CashReceiptListPage';
import CashPaymentListPage from './pages/cash/CashPaymentListPage';
import CashTransferListPage from './pages/cash/CashTransferListPage';
import CashTransactionsPage from './pages/cash/CashTransactionsPage';
import CashSummaryPage from './pages/cash/CashSummaryPage';

// Bank Management Pages
import BankTransactionsPage from './pages/bank/BankTransactionsPage';
import CustomersPage from './pages/Customers';
import CustomerCreate from './pages/Customers/CustomerCreate';
import CustomerEdit from './pages/Customers/CustomerEdit';
import Dashboard from './pages/Dashboard';

// Debug Pages
import DebugTokenPage from './pages/DebugTokenPage';
import ExchangeRateTest from './pages/ExchangeRateTest';
import InventoryStockPage from './pages/inventory/InventoryStockPage';
import WarehouseTransferListPage from './pages/inventory/WarehouseTransferListPage';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MaterialList from './pages/Materials/MaterialList';
import SalespersonSettingsPage from './pages/settings/SalespersonSettingsPage';
import AiSettingsPage from './pages/settings/AiSettingsPage';
import TokenDebugPage from './pages/TokenDebugPage';

// Create a theme with Turkish locale
import CustomerConsistency from './pages/Reports/CustomerConsistency';
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
  },
}, trTR);

// Ana sayfa için rol bazlı yönlendirme
const DefaultRouteRedirect: React.FC = () => {
  const { user, isLoading } = useAuth();
  // Kullanıcı bilgileri yüklenmeden yönlendirme yapma
  if (isLoading) {
    return <div style={{ padding: 24 }}>Yükleniyor...</div>;
  }
  const roles = (user?.roles || []).map(r => String(r).toLowerCase());
  if (roles.includes('ss') || roles.includes('satış sorumlusu')) {
    return <Navigate to="/sales-menu" replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

// Belirli rolleri engelleyen basit guard
const RequireNotRoles: React.FC<{ rolesToBlock: string[], children: React.ReactNode }> = ({ rolesToBlock, children }) => {
  const { user } = useAuth();
  const roles = (user?.roles || []).map(r => String(r).toLowerCase());
  const blocked = rolesToBlock.some(rb => roles.includes(rb.toLowerCase()));
  if (blocked) {
    return <Navigate to="/sales-menu" replace />;
  }
  return <>{children}</>;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <CssBaseline />
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          {/* Oturum süresi uyarıları kaldırıldı - süre bitince direkt logout olacak */}
          <Routes>
              <Route path="/login" element={<Login />} />
              {/* Public Password Reset Routes */}
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              
              {/* Müşteri Kayıt Sayfası - Token ile erişilebilir */}
              <Route path="/customer-registration" element={<CustomerRegistration />} />
              
              {/* Token Bazlı Müşteri Kayıt Sayfası - CustomerCreate'in birebir kopyası */}
              <Route path="/customer-register" element={<CustomerRegister />} />
              
              {/* Başarılı Kayıt Sayfası */}
              <Route path="/registration-success" element={<div style={{padding: '50px', textAlign: 'center'}}>
                <h1>Kayıt Başarılı!</h1>
                <p>Müşteri kaydınız başarıyla oluşturulmuştur. Teşekkür ederiz.</p>
                <button onClick={() => window.location.href = '/'}>Ana Sayfaya Dön</button>
              </div>} />
              
              <Route path="/" element={<MainLayout />}>
                <Route index element={<AuthGuard><DefaultRouteRedirect /></AuthGuard>} />

                <Route path="dashboard" element={<AuthGuard><Dashboard /></AuthGuard>} />
                <Route path="exchange-rate-test" element={<AuthGuard><ExchangeRateTest /></AuthGuard>} />
                
                {/* Sales Mobile Landing for SS role */}
                <Route path="sales-menu" element={<AuthGuard><SalesMenu /></AuthGuard>} />
                <Route path="customer-qr" element={<AuthGuard><CustomerQR /></AuthGuard>} />
                
                {/* Profile Route */}
                <Route path="profile" element={<AuthGuard><ProfilePage /></AuthGuard>} />
                
                {/* Customer Routes */}
                <Route path="customers">
                  <Route index element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><CustomersPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="new" element={<AuthGuard><CustomerCreate /></AuthGuard>} />
                  <Route path="create" element={<AuthGuard><CustomerCreate /></AuthGuard>} />
                  <Route path="edit/:customerCode" element={<AuthGuard><CustomerEdit /></AuthGuard>} />
                  
                  {/* Adresler, İletişim ve E-posta alt sayfaları */}
                  <Route path=":customerCode/addresses" element={<AuthGuard><CustomerDetail tab="addresses" /></AuthGuard>} />
                  <Route path=":customerCode/contacts" element={<AuthGuard><CustomerDetail tab="contacts" /></AuthGuard>} />
                  <Route path=":customerCode/emails" element={<AuthGuard><CustomerDetail tab="emails" /></AuthGuard>} />
                  
                  {/* Dinamik müşteri kodu route'u en sonda olmalı */}
                  <Route path=":customerCode" element={<AuthGuard><CustomerView /></AuthGuard>} />
                </Route>
                
                {/* Invoice Routes - New Structure */}
                <Route path="invoice">
                  <Route path="list" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><InvoiceListPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="create" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><InvoiceCreatePage /></RequireNotRoles></AuthGuard>} />
                  <Route path=":invoiceId" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><InvoiceDetailPage /></RequireNotRoles></AuthGuard>} />
                </Route>
                
                {/* Order Routes */}
                <Route path="orders">
                  <Route index element={<AuthGuard><OrderListPage /></AuthGuard>} />
                  <Route path="list" element={<AuthGuard><OrderListPage /></AuthGuard>} />
                  
                  {/* Satış Siparişleri Rotaları */}
                  <Route path="sales">
                    <Route path="list" element={<AuthGuard><OrderListPage /></AuthGuard>} />
                    <Route path="create" element={<AuthGuard><OrderFormPage orderType="WS" /></AuthGuard>} />
                    <Route path="detail/:orderNumber" element={<AuthGuard><OrderDetailPage /></AuthGuard>} />
                    <Route path="edit/:orderNumber" element={<AuthGuard><OrderFormPage orderType="WS" /></AuthGuard>} />
                  </Route>
                  
                  {/* Satınalma Siparişleri Rotaları */}
                  <Route path="purchase">
                    <Route path="list" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><OrderListPage /></RequireNotRoles></AuthGuard>} />
                    <Route path="create" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><OrderFormPage orderType="BP" /></RequireNotRoles></AuthGuard>} />
                    <Route path="detail/:orderNumber" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><OrderDetailPage /></RequireNotRoles></AuthGuard>} />
                    <Route path="edit/:orderNumber" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><OrderFormPage orderType="BP" /></RequireNotRoles></AuthGuard>} />
                  </Route>
                  
                  {/* Eski rotalar */}
                  <Route path="new" element={<AuthGuard><OrderFormPage orderType="WS" /></AuthGuard>} />
                  <Route path="create" element={<AuthGuard><OrderFormPage orderType="WS" /></AuthGuard>} />
                  <Route path="edit/:orderNumber" element={<AuthGuard><OrderFormPage orderType="WS" /></AuthGuard>} />
                  <Route path=":orderNumber" element={<AuthGuard><OrderDetailPage /></AuthGuard>} />
                </Route>
                
                {/* Invoice Routes - Old Structure (Redirects to new structure) */}
                <Route path="invoices">
                  <Route index element={<Navigate to="/invoice/list" replace />} />
                  <Route path="new" element={<Navigate to="/invoice/create" replace />} />
                  <Route path=":invoiceId" element={<Navigate to="/invoice/:invoiceId" replace />} />
                  <Route path="purchase" element={<Navigate to="/invoice/list?type=purchase" replace />} />
                  <Route path="sales" element={<Navigate to="/invoice/list?type=sales" replace />} />
                  <Route path="wholesale" element={<Navigate to="/invoice/list?type=wholesale" replace />} />
                  <Route path="wholesale-purchase" element={<Navigate to="/invoice/list?type=wholesale-purchase" replace />} />
                </Route>
                
                {/* Product Routes */}
                <Route path="products">
                  <Route index element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><ProductList /></RequireNotRoles></AuthGuard>} />
                  <Route path="new" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><ProductForm /></RequireNotRoles></AuthGuard>} />
                  <Route path="price-list" element={<Navigate to="/price-lists/products" replace />} />
                  <Route path=":productCode" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><ProductDetail /></RequireNotRoles></AuthGuard>} />
                  <Route path="edit/:productCode" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><ProductForm /></RequireNotRoles></AuthGuard>} />
                </Route>
                
                {/* Product Price List Route */}
                <Route path="price-lists/products" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><ProductPriceList /></RequireNotRoles></AuthGuard>} />
                
                {/* User Management Routes */}
                <Route path="users">
                  <Route index element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><Users /></RequireNotRoles></AuthGuard>} />
                </Route>
                
                <Route path="roles">
                  <Route index element={<AuthGuard><Roles /></AuthGuard>} />
                </Route>
                
                <Route path="user-groups">
                  <Route index element={<AuthGuard><UserGroups /></AuthGuard>} />
                </Route>
                
                {/* Vendor Routes */}
                <Route path="vendors">
                  <Route index element={<AuthGuard><VendorList /></AuthGuard>} />
                  <Route path="create" element={<AuthGuard><VendorCreate /></AuthGuard>} />
                  <Route path=":vendorCode" element={<AuthGuard><VendorDetail /></AuthGuard>} />
                  <Route path="edit/:vendorCode" element={<AuthGuard><VendorEdit /></AuthGuard>} />
                </Route>
                
                {/* Supplier Routes - Redirect to Vendors */}
                <Route path="suppliers">
                  <Route index element={<Navigate to="/vendors" replace />} />
                </Route>
                
                {/* Cashier Routes */}
                <Route path="cashier">
                  <Route path="payments" element={<Navigate to="/dashboard" replace />} />
                  <Route path="collections" element={<Navigate to="/dashboard" replace />} />
                </Route>
                
                {/* Materials Routes */}
                <Route path="materials">
                  <Route index element={<Navigate to="/materials/management" replace />} />
                  <Route path="management" element={<AuthGuard><MaterialList /></AuthGuard>} />
                  <Route path="barcodes" element={<Navigate to="/dashboard" replace />} />
                </Route>
                
                {/* Inventory Routes */}
                <Route path="inventory">
                  <Route index element={<Navigate to="/inventory/stock" replace />} />
                  <Route path="stock" element={<AuthGuard><InventoryStockPage /></AuthGuard>} />
                  <Route path="count" element={<Navigate to="/dashboard" replace />} />
                  <Route path="management" element={<Navigate to="/dashboard" replace />} />
                  <Route path="warehouse" element={<Navigate to="/dashboard" replace />} />
                  <Route path="branch" element={<Navigate to="/dashboard" replace />} />
                  <Route path="warehouse-transfers" element={<AuthGuard><WarehouseTransferListPage /></AuthGuard>} />
                  <Route path="warehouse-transfers/new" element={<AuthGuard><WarehouseTransferFormPage /></AuthGuard>} />
                  <Route path="warehouse-transfers/edit/:transferNumber" element={<AuthGuard><WarehouseTransferFormPage /></AuthGuard>} />
                  <Route path="warehouse-transfers/:transferNumber" element={<AuthGuard><WarehouseTransferDetailPage /></AuthGuard>} />
                  <Route path="production-orders" element={<AuthGuard><ProductionOrderListPage /></AuthGuard>} />
                  <Route path="production-orders/new" element={<AuthGuard><ProductionOrderFormPage /></AuthGuard>} />
                  <Route path="production-orders/edit/:innerNumber" element={<AuthGuard><ProductionOrderFormPage /></AuthGuard>} />
                  <Route path="production-orders/:innerNumber" element={<AuthGuard><ProductionOrderDetailPage /></AuthGuard>} />
                  <Route path="consumption-orders" element={<AuthGuard><ConsumptionOrderListPage /></AuthGuard>} />
                  <Route path="consumption-orders/new" element={<AuthGuard><ConsumptionOrderFormPage /></AuthGuard>} />
                  <Route path="consumption-orders/edit/:innerNumber" element={<AuthGuard><ConsumptionOrderFormPage /></AuthGuard>} />
                  <Route path="consumption-orders/:innerNumber" element={<AuthGuard><ConsumptionOrderDetailPage /></AuthGuard>} />
                </Route>
                
                {/* Finance Routes */}
                <Route path="finance">
                  <Route path="exchange-rates" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><ExchangeRatesPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="cross-rates" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><CrossRatesPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="historical-rates" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><HistoricalRatesPage /></RequireNotRoles></AuthGuard>} />
                </Route>
                
                {/* Cash Management Routes */}
                <Route path="cash">
                  <Route path="receipts" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashReceiptListPage /></React.Suspense></AuthGuard>} />
                  <Route path="receipt" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashReceiptPage /></React.Suspense></AuthGuard>} />
                  <Route path="receipt/:voucherNumber" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashReceiptPage /></React.Suspense></AuthGuard>} />
                  
                  <Route path="payments" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashPaymentListPage /></React.Suspense></AuthGuard>} />
                  <Route path="payment" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashPaymentPage /></React.Suspense></AuthGuard>} />
                  <Route path="payment/:voucherNumber" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashPaymentPage /></React.Suspense></AuthGuard>} />
                  
                  <Route path="transfers" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashTransferListPage /></React.Suspense></AuthGuard>} />
                  <Route path="transfer" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashTransferPage /></React.Suspense></AuthGuard>} />
                  <Route path="transfer/:voucherNumber" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashTransferPage /></React.Suspense></AuthGuard>} />
                  
                  <Route path="summary" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashSummaryPage /></React.Suspense></AuthGuard>} />
                  <Route path="transactions" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><CashTransactionsPage /></React.Suspense></AuthGuard>} />
                </Route>
                
                {/* Bank Management Routes */}
                <Route path="bank">
                  <Route path="transactions" element={<AuthGuard><React.Suspense fallback={<div>Yükleniyor...</div>}><BankTransactionsPage /></React.Suspense></AuthGuard>} />
                </Route>
                
                {/* Debug Routes */}
                <Route path="debug">
                  <Route path="token" element={<AuthGuard><DebugTokenPage /></AuthGuard>} />
                  <Route path="tokens" element={<TokenDebugPage />} />
                </Route>
                
                {/* Admin Routes */}
                <Route path="admin">
                  <Route path="exchange-rates-management" element={<AuthGuard><ExchangeRateManagementPage /></AuthGuard>} />
                </Route>
                
                {/* Settings Routes */}
                <Route path="settings">
                  <Route index element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><SettingsPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="users" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><Users /></RequireNotRoles></AuthGuard>} />
                  <Route path="user-groups" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><UserGroups /></RequireNotRoles></AuthGuard>} />
                  <Route path="permissions" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><ModulePermissions /></RequireNotRoles></AuthGuard>} />
                  <Route path="roles" element={<Navigate to="/dashboard" replace />} />
                  <Route path="logs" element={<Navigate to="/settings/audit-logs" replace />} />
                  <Route path="audit-logs" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><React.Suspense fallback={<div>Yükleniyor...</div>}><AuditLogViewer /></React.Suspense></RequireNotRoles></AuthGuard>} />
                  <Route path="databases" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><DatabaseList /></RequireNotRoles></AuthGuard>} />
                  <Route path="user-databases" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><UserDatabaseList /></RequireNotRoles></AuthGuard>} />
                  <Route path="barcode" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><SettingsPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="barcode-settings" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><BarcodeSettingsForm /></RequireNotRoles></AuthGuard>} />
                  <Route path="salespersons" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><SalespersonSettingsPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="database-backup" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><SettingsPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="sql-operations" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><SettingsPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="exchange-rate" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><SettingsPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="user-management" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><SettingsPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="notification-settings" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><SettingsPage /></RequireNotRoles></AuthGuard>} />
                  <Route path="ai" element={<AuthGuard><RequireNotRoles rolesToBlock={["ss", "satış sorumlusu"]}><AiSettingsPage /></RequireNotRoles></AuthGuard>} />
                </Route>

                {/* Reports */}
                <Route path="reports">
                  <Route path="customer-consistency" element={<AuthGuard><CustomerConsistency /></AuthGuard>} />
                </Route>
              </Route>
              
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;